import React from 'react';
import { DialogActions, Button, Box, Tooltip } from '@mui/material';
import { mdiRestore, mdiCheck, mdiClose, mdiChevronLeft, mdiChevronRight, mdiPlusThick } from '@mdi/js';
import Iconn from "@mdi/react";

const DialogActionsComponent = ({
	showReset = true,
	resetText = 'Réinitialiser le formulaire',
	onReset,
	resetConfirmation = 'Voulez-vous réinitialiser le formulaire?',

	showValidate = true,
	validateText = 'VALIDER',
	validateTextIcon = mdiCheck,
	formId,
	onSubmit,

	showClose = true,
	closeText = 'FERMER',
	onClose,

	// Props pour le stepper
	activeStep = 0,
	steps = [],
	onNext,
	onBack,
	nextText = 'SUIVANT',
	backText = 'RETOUR',
	showStepperNavigation = false,

	// Styles personnalisés
	sx = {},
	className = 'dialog-actions',
	handleFunction,
}) => {
	return (
		<DialogActions className={className} sx={sx}>
			{/* Bouton Réinitialiser */}
			{showReset && onReset && (
				<Tooltip title="Réinitialiser le formulaire">
				<Button
					variant="outlined"
					color='secondary'
					onClick={() => {
						if (!resetConfirmation || window.confirm(resetConfirmation)) {
							onReset();
						}
					}}
					sx={{
						"& .MuiButton-startIcon":{
							margin:"0px !important"
						}
					}}
					startIcon={
						<Iconn
							path={mdiRestore}
							size="18px"
						/>
					}
					tabIndex={-1}
				/>
				</Tooltip>
			)}

			<Box sx={{ flex: '1 1 auto' }} />

			{/* Navigation du stepper - Bouton Retour */}
			{showStepperNavigation && activeStep > 0 && onBack && activeStep < steps.length - 1 && (
				<Button
					variant="outlined"
					color='secondary'
					onClick={onBack}
					startIcon={
						<Iconn
							path={mdiChevronLeft}
							size="18px"
						/>
					}
				>
					{backText}
				</Button>
			)}

			{/* Navigation du stepper - Bouton Suivant ou Valider */}
			{showStepperNavigation && activeStep < steps.length - 1 ? (
				<Button
					variant="contained"
					color="secondary"
					onClick={onNext}
					startIcon={
						<Iconn
							path={mdiChevronRight}
							size="18px"
						/>
					}
				>
					{nextText}
				</Button>
			) : showValidate && (
				<Button
					variant="contained"
					type={formId || onSubmit ? "submit" : "button"}
					form={formId}
					startIcon={
						<Iconn
							path={validateTextIcon}
							size="18px"
						/>
					}
					onClick={!formId && onSubmit ? onSubmit : undefined}
				>
					{validateText}
				</Button>
			)}

			{/* Bouton Fermer */}
			{showClose && (!showStepperNavigation || activeStep === steps.length - 1) &&(
				<Button
					variant="outlined"
					color='secondary'
					onClick={onClose}
					sx={{ mr: "4px", ml: "4px" }}
					startIcon={
						<Iconn
							path={mdiClose}
							size="18px"
						/>
					}
				>
					{closeText}
				</Button>
			)}
		</DialogActions>
	);
};

export default DialogActionsComponent;